module.exports = __webpack_public_path__ + "static/media/chrome-mobile-step-2.64620136.png";